import { useEffect, useMemo } from 'react';
import { debounce } from 'helpers/debounce';

export const useDebouncedSearchRefetch = ({
  searchTerm,
  refetch,
  inputVariables,
}: {
  searchTerm: string;
  refetch: (options: { input: any }) => void;
  inputVariables: any;
}) => {
  const debouncedRefetch = useMemo(() => {
    return debounce((value: string) => {
      refetch({
        input: {
          ...inputVariables,
          searchTerm: value.trim() || undefined,
        },
      });
    }, 500);
  }, [refetch, inputVariables]);

  useEffect(() => {
    debouncedRefetch(searchTerm);
  }, [searchTerm, debouncedRefetch]);
};
